<template>
  <div>
    <el-form :model="queryParams" ref="queryForm" :inline="true" class="bg-white p-1">
      <el-form-item label="菜单名称" prop="menuName">
        <el-input
            v-model="queryParams.menuName"
            placeholder="请输入菜单名称"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="10" class="mb8 my-1">
      <el-col :span="1.5">
        <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
            v-hasPermi="['system:menu:add']"
        >新增
        </el-button>
      </el-col>
    </el-row>

    <el-table
        v-loading="searchLoading"
        :data="menuList"
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :header-cell-style="{background: '#DDD'}"
    >
      <el-table-column prop="menuName" label="名称" :show-overflow-tooltip="true" width="160"></el-table-column>
      <el-table-column prop="icon" label="图标" align="center" width="100">
        <template v-slot="scope">
          <i :class="scope.row.icon"></i>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="60"></el-table-column>
      <el-table-column prop="perms" label="权限标识" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="component" label="组件路径" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="menuType" label="类型" :show-overflow-tooltip="true">
        <template v-slot="scope">
          <el-tag v-if="scope.row.menuType===1" type="info">{{ scope.row.menuType | filterMenuType }}</el-tag>
          <el-tag v-else-if="scope.row.menuType===2" type="success">{{ scope.row.menuType | filterMenuType }}</el-tag>
          <el-tag v-else-if="scope.row.menuType===3">{{ scope.row.menuType | filterMenuType }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="hidden" label="隐藏" :show-overflow-tooltip="true"
                       :formatter="hiddenFormat"></el-table-column>
      <el-table-column prop="notes" label="备注" :show-overflow-tooltip="true" width="160"></el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template v-slot="scope">
          <el-button size="mini"
                     type="text"
                     icon="el-icon-edit"
                     @click="handleUpdate(scope.row)"
                     v-hasPermi="['system:menu:edit']"
          >修改
          </el-button>
          <el-button
              size="mini"
              type="text"
              icon="el-icon-plus"
              @click="handleAdd(scope.row)"
              v-hasPermi="['system:menu:add']"
          >新增
          </el-button>
          <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              v-hasPermi="['system:menu:remove']"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加或修改菜单对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="上级菜单">
              <tree-select
                  v-model="form.parentId"
                  :options="menuOptions"
                  :normalizer="normalizer"
                  :show-count="true"
                  placeholder="选择上级菜单"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="类型" prop="menuType">
              <el-radio-group v-model="form.menuType">
                <el-radio label="1">目录</el-radio>
                <el-radio label="2">菜单</el-radio>
                <el-radio label="3">按钮</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="图标类型">
              <el-radio-group v-model="form.iconType" @change="form.icon='',form.iconSelected='',form.iconUnselected=''">
                <el-radio :label="1">系统图标</el-radio>
                <el-radio :label="2" v-if="form.parentId==='0'||form.parentId===0">自定义图标</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item v-if="form.menuType !== '3'&&form.iconType=='1'" label="系统图标">
              <el-popover
                  placement="bottom-start"
                  width="460"
                  trigger="click">
                <Icons @selected="selected" :icon="form.icon"></Icons>
                <el-input slot="reference" v-model="form.icon" placeholder="点击选择图标">
                  <i slot="prefix" class="el-icon-search el-input__icon"/>
                </el-input>
              </el-popover>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.menuType !== '3'&&form.iconType=='2'">
            <el-form-item label="引导页图标">
              <el-upload class="fileUploader" action :accept="'.jpg,.jpeg,.png'" :show-file-list="false" :before-upload="beforeImgUpload" :http-request="({ file }) => { fileUploader(file, 'icon') }">
                <img v-if="form.icon" :src="imageUrlprefix + form.icon"
                  class="accountImg" />
                <p v-else class="upload-text">
                  <i class="el-icon-plus"></i>
                  <i></i>
                  <span>添加引导页图标</span>
                </p>
              </el-upload>
            </el-form-item>
            <el-form-item label="首页菜单选中图标">
              <el-upload class="fileUploader" action :accept="'.jpg,.jpeg,.png'" :show-file-list="false" :before-upload="beforeImgUpload" :http-request="({ file }) => { fileUploader(file, 'iconSelected') }">
                <img v-if="form.iconSelected" :src="imageUrlprefix + form.iconSelected"
                  class="accountImg" />
                <p v-else class="upload-text">
                  <i class="el-icon-plus"></i>
                  <i></i>
                  <span>添加首页菜单选中图标</span>
                </p>
              </el-upload>
            </el-form-item>
            <el-form-item label="首页菜单未选中图标">
              <el-upload class="fileUploader" action :accept="'.jpg,.jpeg,.png'" :show-file-list="false" :before-upload="beforeImgUpload" :http-request="({ file }) => { fileUploader(file, 'iconUnselected') }">
                <img v-if="form.iconUnselected" :src="imageUrlprefix + form.iconUnselected"
                  class="accountImg" />
                <p v-else class="upload-text">
                  <i class="el-icon-plus"></i>
                  <i></i>
                  <span>添加首页菜单未选中图标</span>
                </p>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称" prop="menuName">
              <el-input v-model="form.menuName" placeholder="请输入名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input-number v-model="form.sort" controls-position="right" :min="0"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="form.menuType === '1' || form.menuType === '2' " label="路由" prop="path">
              <el-input v-model="form.path" placeholder="请输入路由"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.menuType === '2'">
            <el-form-item label="组件路径" prop="component">
              <el-input v-model="form.component" placeholder="请输入组件路径"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="form.menuType === '3'" label="权限标识">
              <el-input v-model="form.perms" placeholder="请权限标识" maxlength="50"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="form.menuType !== '3' " label="隐藏">
              <el-radio-group v-model="form.hidden">
                <el-radio
                    v-for="dict in hiddenOptions"
                    :key="dict.dictValue"
                    :label="dict.dictValue"
                >{{ dict.dictLabel }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="form.menuType === '2' " label="KEY">
              <el-input v-model="form.menuKey" placeholder="页面Name"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item v-if="form.menuType === '2' " label="页面参数">
              <el-input v-model="form.pageParam" placeholder="请输入页面参数"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.notes" placeholder="请输入备注"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {menuList, menuDetail, menuAdd, menuUpdate, menuDelete} from "@/api/sys/menu";
import TreeSelect from "@riophae/vue-treeselect";
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Icons from "@/components/Icons";
import { uploadFile } from "@/api/upload/upload"

export default {
  name: "Menu",
  components: {TreeSelect, Icons},
  data() {
    return {
      searchLoading: true,
      // 查询参数
      queryParams: {
        menuName: undefined,
        hidden: undefined
      },
      menuList: [],
      menuOptions: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 显示状态数据字典
      hiddenOptions: [],
      // 表单参数
      form: {
        iconType:1,
        icon:''
      },
      // 表单校验
      rules: {
        menuName: [
          {required: true, message: "名称不能为空", trigger: "blur"}
        ],
        sort: [
          {required: true, message: "顺序不能为空", trigger: "blur"}
        ],
        path: [
          {required: true, message: "路由地址不能为空", trigger: "blur"}
        ],
      }
    }
  },
  created() {
    this.getDicts("if_hidden").then((res) => {
      this.hiddenOptions = res.data;
    })
    this.getList();
  },
  methods: {
    //自定义图标上传
    fileUploader(file, type) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", type);
      uploadFile(formData).then((res) => {
        if (res && res.code == 200 && res.data) {
          this.form[type] = res.data.url;
          this.$forceUpdate()
        }
      });
    },
    //限制图片上传大小
    beforeImgUpload(file){
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传图标图片大小不能超过 5MB!');
      }
      return isLt5M;
    },
    // 选择图标
    selected(name) {
      this.form.icon = name;
    },
    getList() {
      this.loading = true;
      menuList(this.queryParams).then(res => {
        this.menuList = this.handleTree(res.data, "id", "parentId");
        this.searchLoading = false;
      });
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.menuName,
        children: node.children
      };
    },
    /** 查询菜单下拉树结构 */
    getTreeSelect() {
      menuList({}).then(res => {
        this.menuOptions = [];
        const menu = {id: "0", menuName: '主类目', children: []};
        menu.children = this.handleTree(res.data, "id", "parentId");
        this.menuOptions.push(menu);
      });
    },
    handleQuery() {
      this.getList();
    },
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    handleAdd(row) {
      this.reset();
      this.getTreeSelect();
      if (row != null && row.id) {
        this.form.parentId = row.id;
      } else {
        this.form.parentId = 0;
      }
      this.open = true;
      this.title = "添加菜单";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      this.getTreeSelect();
      menuDetail(row.id).then(res => {
        this.form = res.data;
        this.form.menuType = String(this.form.menuType);
        this.open = true;
        this.title = "修改菜单";
      });
    },
    // 显示状态字典翻译
    hiddenFormat(row) {
      if (row.menuType === 3) {
        return "";
      }
      return this.selectDictLabel(this.hiddenOptions, row.hidden);
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        parentId: 0,
        menuName: undefined,
        menuKey: undefined,
        pageParam: undefined,
        iconType:1,
        icon: undefined,
        menuType: "1",
        sort: 1,
        hidden: '0',
      };
      this.resetForm("form");
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id !== undefined) {
            menuUpdate(this.form).then(() => {
              this.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            menuAdd(this.form).then(() => {
              this.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm('是否确认删除名称为"' + row.menuName + '"的数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        return menuDelete(row.id);
      }).then(() => {
        this.getList();
        this.msgSuccess("删除成功");
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// 上传
/deep/.fileUploader{
    width: 180px;
    height: 180px;
    background: #FAFAFA;
    border: 1px solid #D5D5D5;
    .el-upload{
        width: 100%;
        height: 100%;
        // 上传的图片
        img{
          width: 100%;
          height: 100%;
        }
    }
    .upload-text{
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        i{
          font-size: 33px;
        }
        img{
            width: 33px;
            height: 33px;
        }
        span{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
        }
    }
}
</style>
